import { FormEvent } from 'react';
import { AppContext, AppContextType } from '../../AppContextType';
import { Product } from '../../Model/Product';
import { BooleanFilter as BF } from './../../Filter/BooleanFilter';
import { FilterViewProps, OptionsType } from './AbstractFilterView';
import { AbstractToggleFilter } from './AbstractToggleFilter';
import { FilterEvent } from './FilterEvent';
import { FilterOption } from './FilterOption';
import { OptionsCollection } from './OptionsCollection';
import { InputType } from './Toggle/Item';

interface BooleanFilterProps<FILTER_TYPE extends BF = BF> extends FilterViewProps<boolean, FILTER_TYPE> {
}

export class BooleanFilter extends AbstractToggleFilter<boolean, BooleanFilterProps> {
    public static contextType = AppContextType;
    public context: AppContext<Product> = {} as AppContext<Product>;

    protected getType(): InputType {
        return 'radio';
    }

    protected getOptions(): OptionsType<boolean> {
        const i18n = this.context.i18n;

        return new OptionsCollection<boolean>(
            [
                new FilterOption<boolean>('true', i18n.translate('general.boolean_filter.true'), true, false, 'true'),
                new FilterOption<boolean>('false', i18n.translate('general.boolean_filter.false'), true, false, 'false')
            ]
        );
    }

    protected handleInputChange(event: FormEvent<HTMLInputElement>) {
        const target = event.target as HTMLInputElement;
        const isChecked = target.checked;
        const value = target.value;

        const formEvent = new FilterEvent(event, isChecked ? value : undefined);
        this.handleChange(formEvent);
    }
}
